import type { EvidenceState } from './types';

export const formatUsd = (value: number | null, compact = true) => value === null
  ? 'N/A'
  : new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: compact ? 'compact' : 'standard',
      maximumFractionDigits: compact ? 2 : 0,
    }).format(value);

export const formatNumber = (value: number | null, digits = 0) => value === null
  ? 'N/A'
  : new Intl.NumberFormat('en-US', { maximumFractionDigits: digits }).format(value);

export const formatPercent = (value: number | null, digits = 1) => value === null ? 'N/A' : `${(value * 100).toFixed(digits)}%`;
export const formatDate = (value: string | null) => value ? new Date(value).toISOString().slice(0, 10) : 'NOT DISCLOSED';
export const formatUtc = (value: string | null) => value ? new Date(value).toISOString().replace('.000Z', 'Z') : 'N/A';
export const shortAddress = (address: string) => `${address.slice(0, 8)}…${address.slice(-6)}`;
export const stateLabel = (state: EvidenceState) => ({ fresh: 'FRESH', partial: 'PARTIAL', stale: 'STALE', unavailable: 'NOT INDEXED', documentation: 'DOCS CLAIM', illustrative: 'MODEL' })[state];

